import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PreservingDignity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="preserving-dignity" className="bg-background py-24 md:py-40 w-full overflow-hidden">
      <div className="container mx-auto px-6">
        <div ref={ref} className={`max-w-[800px] mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-sm md:text-base font-medium tracking-[0.2em] text-muted-foreground uppercase mb-8 md:mb-10">
            Preserving Dignity through Clarity
          </h2>
          <p className="text-2xl md:text-3xl lg:text-[2rem] font-light text-foreground leading-relaxed md:leading-relaxed">In today’s world, informed decisions are responsible decisions.<div>Verification is about entering important commitments with openness, awareness, and confidence.</div></p>
        </div>
      </div>
    </section>;
}